export enum LocalStorageKeys {
  Token = "token",
  Locale = "lang",
  Utm = "utm",
  LoanValues = "loan_values",
}

export enum SessionStorageKeys {
  PendingUrl = "pending_url",
  RecoveryUrl = "recovery_url",
}

//lang
//utm
